import palette from 'components/palette'
import { OrderType, Position, StateType } from 'data/types'
import { createSelector } from 'reselect'
import { getBaseCurrency } from 'utils/pairs'

import * as configSelectors from '../Config/selectors'
import instrumentSelectors from '../Instrument/selectors'
import ordersSelectors from '../Order/selectors'
import { TickerStateType } from './reducers'
import { PriceLabel } from './types'

const getAll: (state: StateType) => TickerStateType = (state) => state.ticker

// generates a map { 'BTC-USD': 54000, 'ETH-GBP': 1 }
const getMarkPrices = (state) => {
  const ticker = getAll(state)
  return Object.keys(ticker).reduce(
    (acum, symbol) => ({
      ...acum,
      [symbol]: ticker[symbol].mark_price ?? 0
    }),
    {}
  )
}

const getPairMarkPrice: (state: StateType) => number = createSelector(
  getMarkPrices,
  instrumentSelectors.getSymbol,
  (markPrices, pair) => markPrices[pair]
)

const getLabels = (
  orders: OrderType[],
  activePosition: Position | undefined,
  markPrice: number | undefined
) => {
  const labels: PriceLabel[] = []
  if (!activePosition || !markPrice) return labels

  if (markPrice) labels.push({ price: markPrice })

  const positionOrders = orders.filter((order) => order.positionId === activePosition?.positionId)
  for (let i = 0; i < positionOrders.length; i += 1) {
    const order = positionOrders[i]
    labels.push({
      color: order.side === 'buy' ? palette.green400 : palette.red400,
      price: order.price,
      text: `${order.orderQty} ${getBaseCurrency(order.symbol)} ${order.ordType}`
    })
  }

  return labels
}

const getTickerLabels = createSelector(
  ordersSelectors.getOpenOrders,
  ordersSelectors.getSelectedPosition,
  getPairMarkPrice,
  configSelectors.getConfig,
  getLabels
)

export default {
  getAll,
  getMarkPrices,
  getPairMarkPrice,
  getTickerLabels
}
